import { ISearchablePayerPayeeEngagement } from "../../../services/search";
import { IPayerEngagement } from "@wingspanhq/payments/dist/interfaces";

export const selectorIsEngagementsActiveForPayer = (
  engagements: Array<ISearchablePayerPayeeEngagement | IPayerEngagement>
) => {
  const isEngagementsActiveForClient = engagements.some(e => e.engagementId);
  return isEngagementsActiveForClient;
};
